<template>
  <section>
    <div class="paragraph">
      <div class="para-title">
        <div class="tableTitle">
          <span class="midText">{{title}}</span>
        </div>
      </div>
      <div class="para-text">{{content}}</div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.paragraph {
  // padding: 54px 0;
  width: 1200px;
  text-align: center;
  margin: 0 auto;

  .para-title {
    font-size: 20px;
    color: #333333;
    font-weight: bold;
  }
  .para-text {
    font-size: 16px !important;
    color: #999999;
    margin: 19px 48px 0;
    text-align-last: center;
    text-align: justify;
    line-height: 30px;
  }
}
.tableTitle {
  position: relative;
  margin: 0 auto;
  width: 345px;
  height: 1px;
  background-color: #d4d4d4;
  text-align: center;
  font-size: 24px;
  color: rgba(101, 101, 101, 1);
  font-weight: bold;
  font-family: "helvetica neue", "microsoft yahei", "pingfang sc",
    "hiragino sans gb", "stheiti", tahoma, sans-serif;
}
.midText {
  position: absolute;
  left: 50%;
  background-color: #ffffff;
  // background: #F2F2F2;
  padding: 0 15px;
  transform: translateX(-50%) translateY(-50%);
  letter-spacing: 1px;
}
@media (min-width: 768px) {
  .paragraph {
    padding: 135px 0 135px;

    .para-title {
      font-size: 24px;
    }

    .para-text {
      margin-top: 32px;
      font-size: 18px;
      letter-spacing: 1px;
    }
  }
}
@media (max-width: 767.98px) {
  .paragraph {
    // margin-left: 20px;
    // margin-right: 20px;
    width: 100%;
  }
  .tableTitle {
    width: 80%;
    font-size: 18px;
    margin-bottom: 40px;
    margin-top: 80px;
  }
  .para-text {
    display: none;
  }
}
</style>